import cx from 'classnames'
import {ReactNode} from 'react'
import {Field, FieldMetaState} from 'react-final-form'
import {ParsedCountry, PhoneInput} from 'react-international-phone'
import 'react-international-phone/style.css'
import {ErrorMessage} from './ErrorMessage'
import {Label} from './Label'
import {defaultShowError} from './defaultShowError'

type Props = {
  label?: ReactNode
  id?: string
  name: string
  required?: boolean
  placeholder?: string
  className?: string
  validate?: (value: any) => any
  format?: (value: any) => any
  parse?: (value: any) => any
  min?: number
  max?: number
  autoFocus?: boolean
  spellCheck?: boolean
  onChange?: (phone: string, meta: {country: ParsedCountry; inputValue: string}) => any
  showError?: (meta: FieldMetaState<unknown>) => string | undefined
}

export const PhoneInputField = ({
  id,
  label,
  name,
  required,
  placeholder,
  className,
  validate,
  format,
  parse,
  onChange,
  showError = defaultShowError,
}: Props) => {
  return (
    <Field
      validate={validate}
      format={format}
      parse={parse}
      name={name}
      type="tel"
      render={({input, meta}) => {
        const error = showError(meta)
        return (
          <div className={cx('flex flex-col gap-2', className)}>
            {(label || error) && (
              <div className="flex justify-between">
                {label && (
                  <Label htmlFor={id} required={required}>
                    {label}
                  </Label>
                )}
                {error && <ErrorMessage>{error}</ErrorMessage>}
              </div>
            )}
            <PhoneInput
              {...input}
              onChange={(phone: string, meta: {country: ParsedCountry; inputValue: string}) => {
                if (onChange) {
                  onChange(phone, meta)
                }

                input.onChange(phone)
              }}
              inputProps={{id, placeholder}}
              name={name}
              required={required}
              preferredCountries={['us', 'gb', 'fr', 'es', 'ca']}
              className={`flex bg-input-background border-solid border border-input-border text-french-blue-base rounded-lg outline-none block w-full hover:border-gray-3 focus:border-theme ${
                error ? '!border-brand-red' : ''
              }`}
              inputClassName="px-4 py-3 w-full leading-6 placeholder:text-input-placeholder text-base placeholder:text-base placeholder:leading-6 border-0 outline-none bg-input-background h-auto"
              countrySelectorStyleProps={{className: 'my-1 ml-3'}}
            />
          </div>
        )
      }}
    />
  )
}
